<div class="video-container">
  @if (showLogo) {
    <div class="logo-container">
      <img [src]="companyLogo()" (error)="getHowdyLogo()" routerLink="/available-surveys" (click)="goToAvailableSurveys()" class="logo" alt="logo">
        <p class="text">{{ 'WebApp.v1.Shared.AwarenessByHowdy' | translate }}</p>
    </div>
  }

  @if (showAnonymous) {
    <div class="anonymous-container" (click)="openAnswersAnonymousDialog()">
      <div class="box">
        <img class="lock" [src]="s3BaseUrl + 'assets/images/Lock.png'" alt="lock">
        <p class="text">{{ 'WebApp.v1.Shared.Anonymous' | translate }}</p>
      </div>
    </div>
  }

  @if (background) {
    <div class="video-overlay" [style.background]="background"></div>
  }

  @if (videoFailed) {
    <img
      class="video-placeholder"
      [src]="s3BaseUrl + 'assets/images/wallpapers/' + source + '.png'"
      alt="Video placeholder"
    />
  }

  <video #videoElement
    [hidden]="videoFailed"
    class="video"
    loop
    muted
    autoplay
    playsinline
    webkit-playsinline
    preload="metadata"
    [poster]="s3BaseUrl + 'assets/images/wallpapers/' + source + '.png'"
    (error)="onVideoError()"
    (loadeddata)="onVideoLoaded()"
  ></video>
  <ng-content></ng-content>
</div>
